import { Modal } from "antd";
import styled from "styled-components";

export const CustomModal = styled(Modal)`
  width: 65% !important;
  .ant-modal-title {
    font-size: 20px;
  }
`;
